export enum EStepField {
  area = 'area',
  districts = 'districts',
  streets = 'streets',
  undergrounds = 'undergrounds',
  location = 'location',
}
